/* eslint-disable max-len */
import { Component, EventEmitter, Input, OnInit, Output, ViewChild, inject, DestroyRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TenantService } from 'src/app/services/api/tenant.service';
import { translate } from '@jsverse/transloco';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { InstancesService } from 'src/app/services/api/instances.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { Subscription } from 'rxjs';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { ColumnFilterComponent } from '../instances-mgmt/column-filter/column-filter.component';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionTypes } from 'src/app/models/subscription.model';
import { ClipboardService } from 'ngx-clipboard';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { UrlService } from 'src/app/services/util/url.service';
import { Router } from '@angular/router';
import { RouterSegments } from 'src/app/models/router-segments';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permission } from 'src/app/models/principal/permission';

const REQUIRED_PERMISSIONS = [
  Permission.DEPLOY_INGRESS_SERVICES,
];
@Component({
    selector: 'app-shared-services',
    templateUrl: './shared-services.component.html',
    styleUrls: ['./shared-services.component.scss'],
    standalone: false
})
export class SharedServicesComponent  implements OnInit {
  private destroyRef = inject(DestroyRef);

  @ViewChild(MatSort, { static: true }) sort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  RouterSegments = RouterSegments;
  DeployStatus = DeployStatus;
  breadcrumbItems: BreadcrumbItem[];
  Permission = Permission;
  permissionsMap: { [key: string]: boolean };
  tenant: string;
  showSpinner: any;
  searchSolutionText: any;
  dropdownsList: any = [];
  dashboardLink: any;
  pageSize: number;
  pageNumber = 1;

  paginationSize = 10;
  pageIndex = 0;
  showPagination = true;
  sortInfo: any;
  tenantList: any;
  tenantId: any;
  filteredColumns: any;
  clearData: boolean;
  selectedDefaultFilter: any;
  data: any;
  isLoading: boolean;
  copy = false;
  sharedServicesLink: any;
  showNoSharedServices: any;
  subscriptionIdPii: any;
  subscriptionNamePii: any;
  subDataZonePii: any;
  subscriptionIdNonPii: any;
  subscriptionNameNonPii: any;
  subDataZoneNonPii: any;
  accountIdNonProdPii: any;
  accountNameNonProdPii: any;
  accountEmailNonProdPii: any;
  accDataZoneNonProdPii: any;
  accountIdNonPii: any;
  accountNameNonPii: any;
  accountEmailNonPii: any;
  accDataZoneNonPii: any;
  accountIdProdPii: any;
  accountNameProdPii: any;
  accountEmailProdPii: any;
  accDataZoneProdPii: any;
  DeployStatusPii: boolean;
  DeployStatusNonPii: boolean;
  DeployStatusNonProdPii: boolean;
  DeployStatusProdPii: boolean;
  piiData = [];
  nonPiiData = [];
  DeployIngressPii: boolean;
  DeployServicesPii: boolean;
  DeployIngressNonPii: boolean;
  DeployServicesNonPii: boolean;
  servicePii = [{value: 'SFTP' , response: 'sftp', selected: false, default: false}, {value: 'Temn Monitor' ,response: 'temnmonitor', selected: false, default: false}, {value: 'External MQ' ,response: 'external_messaging', selected: false, default: false}];
  serviceNonPii = [ {value: 'SFTP' ,response: 'sftp', selected: false, default: false}, {value: 'Temn Monitor' ,response: 'temnmonitor',  selected: false, default: false}, {value: 'External MQ' ,response: 'external_messaging', selected: false, default: false}];
  tenantDetailsData: any;
  accountData: any;
  isDataLoading: any;
  servicePiiFalseCount: number;
  serviceNonPiiFalseCount: number;

  constructor(private route: ActivatedRoute, private authService: AuthService, private instanceService: InstancesService,
    private sidenavService: SidenavService, private toastrService: CustomToastrService, private tenantService: TenantService,
    public dateTimeFormatService: DateTimeFormatService, private solutionsService: SolutionsService, private toastrErrorService: ToastrErrorService, private dialog: MatDialog, private clipboardApi: ClipboardService,
    private urlService: UrlService, private router: Router,private permissionsService: PermissionsService) {
    
  }

  ngOnInit(): void {
    this.permissionsMap = this.permissionsService.resolveUserPermissions(REQUIRED_PERMISSIONS);
    this.DeployStatusNonPii = false;
    this.DeployStatusPii = false;
    this.DeployStatusNonProdPii = false;
    this.DeployStatusProdPii = false;
    this.sidenavService.selectedMenu = 'LEFT_SIDE_NAV.SHARED_SERVICES';
    // Getting a localstorage item where we have stored a tenantId to get assigned.
    this.tenantId = localStorage.getItem('filteredSharedServices');
    if(this.tenantId) {
      this.isLoading = true;
      this.loadData(this.tenantId);
    }
    this.dashboardLink = ({ label: translate('LEFT_SIDE_NAV.TENANT_ONBOARDING') });
    this.sharedServicesLink = ({ label: translate('LEFT_SIDE_NAV.SHARED_SERVICES'), url: ['shared-services'] });
    this.breadcrumbs();
    this.dropdownsList = [
      {
        title: 'Tenant',
        placeholder: translate('INSTANCE_LIST.SELECT_TENANT'),
        key: 'tenant',
        options: []
      },
    ];

    this.clearData = true;
    this.tenant = this.authService.principal.provider;
    this.getTenants();
    this.showNoSharedServices = true;
  }

  /**
   * Getting a tenant List to be displayed in filter removing all the external tenants.
   */
  getTenants(): void {
    this.dropdownsList[0].options = [];
    this.tenantService.getTenants()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {
        if (data) {
          data = data.filter(value => value.managementType !== 'external' && value.tenantId !== 'temenos.com');
          this.tenantList = [...new Set(data.map(item => item.tenantId).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
          this.tenantList.forEach((value) => {
            this.dropdownsList[0].options.push({ value, selected: false });
          });
        }
      });
  }

  loadData(tenantId): void {
    this.subscriptionIdPii = '';
    this.subscriptionIdNonPii = '';
    this.accountIdNonPii = '';
    this.accountIdNonProdPii = '';
    this.accountIdProdPii = '';
    this.isDataLoading = true;
    this.tenantService.getTenantDetails(tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(data => {
      this.tenantDetailsData = data;
      const gitlabUrl = this.tenantDetailsData?.sharedServices?.nonprod?.gitlabUrl;
      if (gitlabUrl && gitlabUrl.endsWith('.')) {
        this.tenantDetailsData.sharedServices.nonprod.gitlabUrl = gitlabUrl.substring(0, gitlabUrl.length - 1);
      }
      const keycloakUrl = this.tenantDetailsData?.sharedServices?.nonprod?.keycloakUrl;
      if (keycloakUrl && keycloakUrl.endsWith('.')) {
        this.tenantDetailsData.sharedServices.nonprod.keycloakUrl = keycloakUrl.substring(0, keycloakUrl.length - 1);
      }
      const gitlabUrlProd = this.tenantDetailsData?.sharedServices?.prod?.gitlabUrl;
      if (gitlabUrlProd && gitlabUrlProd.endsWith('.')) {
        this.tenantDetailsData.sharedServices.prod.gitlabUrl = gitlabUrlProd.substring(0, gitlabUrlProd.length - 1);
      }
      const keycloakUrlProd = this.tenantDetailsData?.sharedServices?.prod?.keycloakUrl;
      if (keycloakUrlProd && keycloakUrlProd.endsWith('.')) {
        this.tenantDetailsData.sharedServices.prod.keycloakUrl = keycloakUrlProd.substring(0, keycloakUrlProd.length - 1);
      }
      if (this.tenantDetailsData?.sharedServices?.prod?.keycloakUrl && this.tenantDetailsData?.sharedServices?.prod?.keycloakUrl?.startsWith('https://')){
        this.tenantDetailsData.sharedServices.prod.keycloakUrl = this.tenantDetailsData?.sharedServices?.prod?.keycloakUrl;
      } else if(this.tenantDetailsData?.sharedServices?.prod?.keycloakUrl){
        this.tenantDetailsData.sharedServices.prod.keycloakUrl = 'https://'+ this.tenantDetailsData?.sharedServices?.prod?.keycloakUrl;
      }
      if (this.tenantDetailsData?.sharedServices?.nonprod?.keycloakUrl && this.tenantDetailsData?.sharedServices?.nonprod?.keycloakUrl?.startsWith('https://')){
        this.tenantDetailsData.sharedServices.nonprod.keycloakUrl = this.tenantDetailsData?.sharedServices?.nonprod?.keycloakUrl;
      } else if(this.tenantDetailsData?.sharedServices?.nonprod?.keycloakUrl){
        this.tenantDetailsData.sharedServices.nonprod.keycloakUrl = 'https://'+ this.tenantDetailsData?.sharedServices?.nonprod?.keycloakUrl;
      }
      if (this.tenantDetailsData?.sharedServices?.nonprod?.gitlabUrl && this.tenantDetailsData?.sharedServices?.nonprod?.gitlabUrl?.startsWith('https://')){
        this.tenantDetailsData.sharedServices.nonprod.gitlabUrl = this.tenantDetailsData?.sharedServices?.nonprod?.gitlabUrl;
      } else if(this.tenantDetailsData?.sharedServices?.nonprod?.gitlabUrl){
        this.tenantDetailsData.sharedServices.nonprod.gitlabUrl = 'https://'+ this.tenantDetailsData?.sharedServices?.nonprod?.gitlabUrl;
      }
      this.isDataLoading = false;
      if (this.tenantDetailsData?.sharedServices?.prod?.optionalComponents?.length > 0){
        this.servicePii.filter((item) => {
          this.tenantDetailsData?.sharedServices?.prod?.optionalComponents.filter((component) => {
          if(item.response === component )
              item.default = true;
          });
        });
        this.servicePiiFalseCount = this.servicePii.filter(item => item.default === false).length;
      }
      if (this.tenantDetailsData?.sharedServices?.nonprod?.optionalComponents?.length > 0){
        this.serviceNonPii.filter((item) => {
          this.tenantDetailsData?.sharedServices?.nonprod?.optionalComponents.filter((component) => {
            if(item.response === component )
              item.default = true;
          });
        });
        this.serviceNonPiiFalseCount = this.serviceNonPii.filter(item => item.default === false).length;
      }
    });
    this.tenantService.getTenantAccountDetails(tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        if (data) {
          this.accountData = data;
          this.accountData?.forEach(item => {
            if(item?.azureDetails) {
              if(item?.dataZone === SubscriptionTypes.PII) {
                this.subscriptionIdPii = item?.azureDetails?.subscriptionId;
              } else {
                this.subscriptionIdNonPii = item?.azureDetails?.subscriptionId;
              }
            }
            if(item?.awsDetails) {
              if(item?.dataZone === SubscriptionTypes.AWS_NON_PII) {
                this.accountIdNonPii = item?.awsDetails?.accountId;
              } else if(item?.dataZone === SubscriptionTypes.AWS_NONPROD_PII){
                this.accountIdNonProdPii = item?.awsDetails?.accountId;
              } else if(item?.dataZone === SubscriptionTypes.PROD_PII){
                this.accountIdProdPii = item?.awsDetails?.accountId;
              }
            }
          });
        }
      });
   }

   onCopyId(data): void {
    this.copy = true;
    this.clipboardApi.copyFromContent(data);
    setTimeout(() => {
      this.copy = false;
    }, 500);
  }

   closeSidenav(): void {
    this.sidenavService.closeRightSidenav();
  }

  selectOptionsServicePii(data): void {
    this.servicePii.filter((item) => {
      if (item.value === data) {
        if(item.selected) {
          item.selected = false;
          const pii = this.piiData.indexOf(data);
          if (pii > -1) {
            this.piiData.splice(pii, 1);
          }
        } else {
          item.selected = true;
          this.piiData.push(item.value);
        }
      }
    });

  }

  selectOptionsServiceNonPii(data): void {
    this.serviceNonPii.filter((item) => {
      if (item.value === data) {
        if(item.selected) {
          item.selected = false;
          const nonPii = this.nonPiiData.indexOf(data);
          if (nonPii > -1) {
            this.nonPiiData.splice(nonPii, 1);
          }
        } else {
          item.selected = true;
          this.nonPiiData.push(item.value);
        }
      }
    });
  }

  /**
   * On clicking Deploy button, shared services will get deployed in the specific environment.
   * @params - Environment value to be deployed. 
   */
  onClickDeployService(value): void {
    const message = (value === SubscriptionTypes.PII ? translate('TENANT_DETAILS.SHARED_MESSAGE_PROD') : translate('TENANT_DETAILS.SHARED_MESSAGE_NON_PROD'));
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('TENANT_DETAILS.EDGE_TITLE'),
        message: message,
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
        if(value === SubscriptionTypes.PII) {
          this.DeployServicesPii = true;
          const component  = [];
          this.servicePii.forEach(element => {
           if(element.selected === true) {
            component.push(element.response);
           } 
          });
          const piiData: any = {
            tenantId : this.tenantId,
            prod: true,
            components: component
          };
          this.tenantService.postTenantSharedServiceDetails(piiData)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(pii => {
            this.servicePii.forEach(element => {
              if(element.selected === true) {
               component.push(element.response);
               if(component.length === 2) {
                this.DeployServicesPii = true;
               } else {
                this.DeployServicesPii = false;
               }
            setTimeout(() => {
              const title = translate('EDGE_NETWORK_DETAILS.SHARED_SERVICES');
              const message = translate('TENANT_DETAILS.EDGE_MESSAGE_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
              } 
             });
          },
          (error) => {
          const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {title: translate('ERROR_DIALOG.SHARED_PROD_FAILED'),
            description: errorMessage
          }})
            this.DeployServicesPii = false;
          });
          this.DeployServicesPii = false;
        } else if(value === SubscriptionTypes.AWS_NONPROD_PII) {
          this.DeployServicesNonPii = true;
          const component  = [];
          component.push();
          this.serviceNonPii.forEach(element => {
            if(element.selected === true) {
             component.push(element.response);
            } 
           });
          const nonPiiData: any = {
            tenantId : this.tenantId,
            nonprod: true,
            components: component
          };
          this.tenantService.postTenantSharedServiceDetails(nonPiiData)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(nonPii => {
            this.serviceNonPii.forEach(element => {
              if(element.selected === true) {
               component.push(element.response);
               if(component.length === 2) {
                this.DeployServicesNonPii = true;
               } else {
                this.DeployServicesNonPii = false;
               }
            setTimeout(() => {
              const title = translate('EDGE_NETWORK_DETAILS.SHARED_SERVICES');
              const message = translate('TENANT_DETAILS.EDGE_MESSAGE_SUCCESS');
              this.toastrService.successMessage(message, title);
            }, 500);
              } 
             });
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
          this.dialog.open(ErrorDialogComponent, {
            minHeight: '342px',
            width: '630px',
            panelClass: 'flex-dialog',
            data: {title: translate('ERROR_DIALOG.SHARED_NON_PROD_FAILED'),
            description: errorMessage
          }})
            this.DeployServicesNonPii = false;
          });
        }
      }
    });
  }

  breadcrumbs(): void {
    this.breadcrumbItems = [];
    this.breadcrumbItems.push({ icon: 'assets/images/home_icon.svg' }, { label: this.dashboardLink?.label, url: [] }, {
      label: this.sharedServicesLink?.label,
      url: this.sharedServicesLink?.url
    });
  }

  closeMenu(data): void {
    this.clearData = false;
    this.sidenavService.searchFilter.next(data);
    this.filteredColumnsFunction(data);
  }

  defaultFilterChanged(option): void {
    this.dropdownsList[0].selectedValue = option.key;
    this.selectedDefaultFilter = option;
  }

  filterColumns(): void {
    if (this.tenantId) {
      this.dropdownsList[0].options.filter((item) => {
        if (item.value === this.tenantId) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[0].options.filter((item) => {
        item.selected = false;
      });
    }
    const data = {
      name: translate('SUBSRIPTION.SUBSCRIPTION'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      tenant: this.dropdownsList[0].options,
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filteredColumns => {
        if (filteredColumns[0] !== undefined) {
          this.clearData = true;
          this.isLoading = true;
          this.filteredColumns = filteredColumns;
          if (filteredColumns[0] !== '') {
            this.tenantId = filteredColumns[0];
            if(this.tenantId) {
              localStorage.setItem('filteredSharedServices', this.tenantId);
            }
          }
          this.loadData(this.tenantId);
        } else {
          this.resetFilter();
        }
      },
      (error) => {
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

  filteredColumnsFunction(dataDeselected): void {
    if (dataDeselected) {
      if (this.tenantId === dataDeselected) {
        this.tenantId = undefined;
        this.resetValue(this.dropdownsList[0]);
      };
    }
  }

  resetFilter(): void {
    this.tenantId = undefined;
    this.tenantDetailsData = undefined;
    this.isLoading = false;
    this.clearData = false;
    this.resetAllValues();
  }

  resetValue(closedItem): void {
    closedItem?.options?.forEach(element => {
      element.selected = false;
    });
  }

  resetAllValues(): void {
    this.dropdownsList.forEach(element => {
     element?.options?.forEach(item => {
       item.selected = false;
     });
   });
  }
}


